/* eslint-disable react/jsx-closing-bracket-location */
import React, { createContext, useState, ReactNode, ReactElement } from 'react';
import {
  ILiveMatchContext,
  IPrefferencesContext,
  ITransformFootballMatch
} from '../interfaces/interfaces';

export const LiveMatchContext = createContext({} as ILiveMatchContext);
export const PrefferencesContext = createContext({} as IPrefferencesContext);

export const PrefferencesProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [language, setLanguage] = useState<string>('');
  const [parentHost, setParentHost] = useState<string>('');
  const [widgetWidth, setWidgetWidth] = useState<number>(0);

  return (
    <PrefferencesContext.Provider
      value={{
        language,
        setLanguage,
        parentHost,
        setParentHost,
        widgetWidth,
        setWidgetWidth
      }}>
      {children}
    </PrefferencesContext.Provider>
  );
};

export const LiveMatchProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [liveMatchData, setLiveMatchData] = useState({} as ITransformFootballMatch);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [matchId, setMatchId] = useState<string>('');
  const [sportType, setSportType] = useState<string>('');

  const matchState = {
    liveMatchData,
    isLoading,
    matchId,
    sportType,
    setMatchId,
    setIsloading,
    setLiveMatchData,
    setSportType
  };

  return (
    <LiveMatchContext.Provider value={matchState}>
      <PrefferencesProvider>{children}</PrefferencesProvider>
    </LiveMatchContext.Provider>
  );
};
